import template from './mx-search-grouped-context-list.html';

export class MxSearchGroupedContextListComponentController {
	static $inject = [];

	constructor() {}

	$onChanges(changes) {
		if (changes.searchContexts?.currentValue?.length) {
			this.searchContextGroups = this.groupContextsByTopLevelNavParents(changes.searchContexts.currentValue);
		}
	}

	groupContextsByTopLevelNavParents(contexts) {
		const groupsObj = {};

		contexts.forEach((context) => {
			let navigationItem = context.navigationItem;
			while (navigationItem.parent) {
				navigationItem = navigationItem.parent;
			}
			groupsObj[navigationItem.title] = groupsObj[navigationItem.title] || {
				groupName: navigationItem.title,
				searchContexts: [],
				index: navigationItem.index,
			};
			groupsObj[navigationItem.title].searchContexts.push(context);
		});

		let groups = Object.values(groupsObj).sort((a, b) => a.index - b.index);

		const baseGroup = {
			groupName: '-',
			searchContexts: [],
			index: 0,
		};
		groups = groups.filter((group) => {
			if (group.searchContexts.length < 2 && group.searchContexts[0]?.title === group.groupName) {
				baseGroup.searchContexts.push(...group.searchContexts);
				return false;
			}
			return true;
		});

		if (baseGroup.searchContexts.length) {
			groups.unshift(baseGroup);
		}

		if (groups.length === 1) {
			groups[0].groupName = '';
		}

		return groups;
	}

	hasSelectedContexts() {
		return this.searchContexts.some((context) => context.selected);
	}
}

angular.module('mx.shell').component('mxSearchGroupedContextList', {
	controller: MxSearchGroupedContextListComponentController,
	controllerAs: 'vm',
	template: template,
	bindings: {
		onSelect: '&',
		searchContexts: '<',
	},
});
